import type { DocuSignReturnMessage } from './DocuSignReturnMessage'

export const isDocuSignReturnMessage = (value: unknown): value is DocuSignReturnMessage => {
  if (typeof value !== 'object' || value === null) {
    return false
  }

  return (
    Reflect.get(value, 'type') === 'DOCUSIGN_RETURN' &&
    typeof Reflect.get(value, 'event') === 'string'
  )
}
